export const GRAPHQL_VARIABLES = {};

export const QUERY = `
mutation {
  applyFatZebra {
    status
    errors {
      field
      reasons
    }
  }
}
`;
